// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { Transition } from '@uirouter/angular';
import { Agreement } from '@tdwb/lazy/platform/preferences';
import { type StatesList } from '@tdwb/webbroker/core';

import {
  ConsolidatedAgreementsModalComponent
} from '../common/consolidated-agreements-form/consolidated-agreements.modal.component';

import { OldAgreementsModalComponent } from './old-agreements/old-agreements.modal.component';
import { CurrentAgreementsModalComponent } from './current-agreements/current-agreements.modal.component';
import { UnsignedAgreementsComponent } from './unsigned-agreements.component';

export abstract class AgreementsResolver {
  static resolveAgreements(transition: Transition): Array<Agreement> {
    return transition.params().agreements;
  }

  static resolvePagingMode(transition: Transition): boolean {
    return transition.params().pagingMode;
  }

  static resolveItemsIndex(transition: Transition): number {
    return transition.params().itemsIndex;
  }

  static resolveAgreement(transition: Transition): Promise<Agreement> {
    return transition.params().agreement;
  }
}

export class AgreementsRoutes {
  static states: StatesList = [
    {
      name: 'modal.preferences-agreements',
      url: '/preferences/agreements',
      params: {
        agreements: {
          type: 'any'
        },
        itemsIndex: {
          type: 'any'
        },
        pagingMode: {
          type: 'any'
        }
      },
      data: {
        modalOptions: {
          component: CurrentAgreementsModalComponent
        }
      },
      resolvePolicy: { when: 'EAGER', async: 'WAIT' },
      resolve: [
        {
          token: 'agreements', deps: [Transition], resolveFn: AgreementsResolver.resolveAgreements
        },
        {
          token: 'pagingMode', deps: [Transition], resolveFn: AgreementsResolver.resolvePagingMode },
        {
          token: 'itemsIndex', deps: [Transition], resolveFn: AgreementsResolver.resolveItemsIndex
        }
      ]
    },
    {
      name: 'modal.preferences-agreements-old',
      url: '/preferences/agreements/old',
      component: OldAgreementsModalComponent,
      params: {
        agreementType: {
          type: 'string'
        }
      }
    },
    {
      name: 'modal.unsigned-agreements',
      url: '/unsigned-agreements',
      data: {
        modalOptions: {
          component: UnsignedAgreementsComponent,
          size: 'full-screen',
          closeOnEscapeKey: false
        }
      }
    },
    {
      name: 'modal.agreement-details',
      url: '/agreement-details',
      data: {
        modalOptions: {
          component: ConsolidatedAgreementsModalComponent
        }
      },
      params: {
        agreement: {
          type: 'any'
        }
      },
      resolve: [
        {
          token: 'agreement',
          deps: [Transition],
          resolveFn: AgreementsResolver.resolveAgreement,
          policy: { when: 'EAGER', async: 'WAIT' }
        }
      ]
    }
  ];
}
